import React, { useContext, useState } from 'react';
import { compose, map, toPairs } from 'ramda';
import styles from './css/utilsReact.scss';
import { Route } from 'react-router-dom';
import { store } from './login/store';

const dumpData = data =>
	data.map((row, index) => (
		<div key={index} className={styles.top}>
			{compose(
				map(([k, v]) => (
					<div className={styles.objectProp} key={k}>
						<span>{k}</span>
						<span>{v}</span>
					</div>
				)),
				toPairs
			)(row)}
		</div>
	));

function RouteWithProps({
	component: Component,
	render,
	componentProps,
	...rest
}) {
	return (
		<Route
			{...rest}
			render={routeProps =>
				render ? (
					render({ ...componentProps, ...routeProps })
				) : (
					<Component {...componentProps} {...routeProps} />
				)
			}
		/>
	);
}

function SecureRouteWithProps({
	component: Component,
	componentProps = {},
	children,
	render,
	...rest
}) {
	const {
		state: { auth }
	} = useContext(store);

	return (
		<Route
			{...rest}
			render={routeProps =>
				auth.session ? (
					Component ? (
						<Component {...componentProps} {...routeProps} />
					) : children ? (
						children
					) : (
						render && render(routeProps)
					)
				) : null
			}
		/>
	);
}
function useFunctionAsState(fn) {
	const [val, setVal] = useState(() => fn);

	function setFunc(fn) {
		setVal(() => fn);
	}

	return [val, setFunc];
}

export { dumpData, RouteWithProps, useFunctionAsState, SecureRouteWithProps };
